import feedbackTypes from '../../constants/feedbackTypes'
export * from './get'
export * from './get_questions'
export * from './getindex'
export * from './read'
export * from './unread'
export * from './resolved'

const set_feedback_errors = (messages) => {
  return {
    type: feedbackTypes.set_errors,
    payload: messages
  }
}
//
// const reset_feedback = () => {
//   return {
//     type: feedbackTypes.reset_feedback
//   }
// }
//
// const clear_feedback = () => {
//   return {
//     type: feedbackTypes.clear_feedback
//   }
// }

export {
  set_feedback_errors,
  // reset_feedback,
  // clear_feedback
}



// WEBPACK FOOTER //
// ./src/js/actions/feedback/index.js